var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.875 8.544.6 10 .4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M20.308 23.948c-.037-.048-.057-.184-.068-.194-.561-.5-.81-1.084-.81-1.76-.282.421-.924.366-.924-.354.585.288.965-.01 1.25-1.35.101-.476.514-1.003.948-1.364-.518.465-.813 1.54-.757 2.282.048.632.507.643.969.377.045.697-.484.841-.845.587.226.431.226 1.184.338 1.416.014.029.127.12.147.216.033.163.394.203.3.531a.38.38 0 0 1 .251.172c.085.15.44.338.58.366-.022.03-.263.443-.58.586-.324.147-.726.023-.771 0 .146-.005.156-.405.135-.57-.025-.198-.01-.318.026-.395-.23-.117-.084-.408-.19-.546Zm-.153-10.354c.03-.266-.027-.539-.225-.71-.382-.33-.756-.221-1.034.045-.417-.222-.638.564-1.111.43.078.255.202.366.439.277-.248.222 0 .488-.293.753.53.166.811-.121.788-.62.203.178.518.166.687-.033-.281-.088-.282-.33-.169-.553.17-.332.963-.32.918.411Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M21.378 17.445c-.598.31-1.69.177-1.791-.587-.102-.764.653-1.107.856-1.207.316-.155.563.122.461.443a.5.5 0 0 0 .26-.753c.461.034.89-.31 1.07-.797-.163.152-.604.05-.968.026.113-.122.112-.358.078-.48-.383.388-.935.21-1.667 1.329.113-.388.327-1.163.45-1.672.013-.05.022-.1.028-.153.045-.73-.747-.744-.916-.412.185.206.087.445.021.809-.079.431-.248 1.428-.394 1.76-.045-.52-.394-.554-.462-.808-.101.066-.157.243-.135.365-.124-.133-.552.033-.71-.166-.168.332.102.664.383.808-.163.011-.202.205-.382.205.242.277.49.387.777.41.287.022.5.127.675.47.282.553 1.355.913 2.366.41Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M22.864 16.77c-.338.918-1.262 1.571-1.678 1.67-.71.17-2.156.86-2.544 1.216a.459.459 0 0 1-.16-.064c-.19-.133-.348-.564-.01-.93 1.058-.974 2.196-.553 2.905-1.217-.597.31-1.689.177-1.79-.587a2.782 2.782 0 0 0 2.725-.797c.124.133.484.553.552.708Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M20.703 18.926c-.535.446-.812 1.54-.756 2.282.016.207.075.347.164.432.04-.42.337-1.507 1.097-1.992.642-.41 1.645-1.329 2.016-2.38-.067-.189-.18-.322-.394-.454-.368.992-1.355 1.468-2.127 2.112Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M18.472 18.662c-.861.792-.293 1.484.045 1.639-.09.553.439.487.428.952.214-.122.27-.443.236-.698.27.288.957-.033 1.104.498.09-.586-.372-1.173-.946-1.118.236-.21.101-.553-.124-.642-.045.432-.54.432-.732.3-.192-.134-.35-.565-.011-.93Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M26.614 18.673c1.386 1.14 1.476 2.048 1.262 2.58-.113-.498-.687-1.273-1.284-1.473l.022-1.107Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M24.137 18.031h2.567v2.99c0 2.545-1.441 4.05-2.905 4.848-1.464-.797-2.906-2.303-2.906-4.849v-2.989h1.802a.955.955 0 0 0 .203.62c.425-.041.906-.354 1.239-.62Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M26.704 18.031v2.99c0 .768-.131 1.442-.355 2.03l-2.55-4.599-2.55 4.599a5.663 5.663 0 0 1-.356-2.03v-2.99h5.811Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F7E017",
      d: "M26.427 22.83a5.46 5.46 0 0 1-.19.491l-2.438-4.454-2.439 4.454a5.431 5.431 0 0 1-.19-.49l2.63-4.791 2.628 4.79Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      d: "M25.59 17.452a.55.55 0 0 1 .112.578h-1.594s-.75.56-1.21.621c-.293-.343-.277-.997.094-1.307-.192-.544-.598-1.143-.878-1.402a2.783 2.783 0 0 0-.534-.036c.147-.31.564-.636.902-.77.054-.078.113-.153.168-.22.034-.427 2.095-.228 2.534.038 0 .476.191 2.067.405 2.498Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M26.614 18.673c.946.642 1.645 1.262 1.847 2.259.203.996.586 1.262 1.059.996-.113.576-.698.642-1.194.2.045.663-.225 1.46-.923 1.748-.045-.398.223-.714.146-1.04-.034-.144-.045-.476.146-.631-.371.122-.957-.111-1.013-.653.428.199.98.232 1.194-.3.214-.53.124-1.438-1.262-2.579Zm1.194-5.18c.293-.753 1.059-.676 1.318-.355.754-.42.856.532 1.498.344-.012.177-.226.343-.462.332.248.221-.101.553.428.752-.45.222-1.081-.01-1.25-.62-.147.288-.676.288-.89.056.462-.122.428-.543.17-.709-.262-.167-.722-.1-.812.2Zm-2.504 1.383c.21.666.865 1.56 1.333 1.982.54.487 1.357.365 1.813-.1.011.927-.965 1-1.509.709-.24-.128-.433-.061-.203.144.35.31 1.113.54 2.016.73 1.577.332 1.014 1.561.552 1.55.132-.003.241-.139.05-.307-.526-.466-2.512-.984-3.259-1.815-1.193-1.326-1.078-2.974-.793-2.893Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M26.94 17.467c.654.42 1.392.42 2.073-.354.214-.244.552-.454.788-.476.237-.023.226-.244.406-.288-.113-.034-.158-.166-.327-.15.422-.144.299-.476.507-.636-.169.06-.434-.189-.676.127.062-.144-.022-.316-.084-.382.022.166-.332.2-.4.62-.038.236-.169.221-.192-.144-.016-.267-.146-1.007-.303-1.384-.158-.376-.194-.893.02-.97a.42.42 0 0 0-.133-.137c-.261-.167-.72-.1-.811.2-.293.752.53 1.184.462 2.003-.124-.609-1.127-.764-1.115-1.361-.327.144-.282.41-.158.62-.203-.31-.664.199-1.059-.222-.045.554.451.764.856.786-.202.354.068.653.338.753.011-.62 1.305-.366 1.318.697.011.908-.98.986-1.51.698Zm1.814.874c1.577.332 1.014 1.561.552 1.55-.294-.007-.574-.249-.591-.46-.338.178-.248.526.011.665-.71-.083-1.008.376-1.025.88.13-.232.524-.25.67-.2.147.05.524.078.676-.088-.124.105.079.349-.096.537.591-.022.85-.565.75-.803.765-.686.619-1.804-.947-2.08Zm-1.416 6.14c.263-.12.113-.452.236-.6.07-.085.082-.217-.02-.28-.086-.053-.205-.076-.25.108-.044.18-.45.21-.358.58a.422.422 0 0 0-.29.18c-.1.164-.504.359-.663.384.026.038.179.485.567.653.446.194.869.08.916.06-.163-.013-.157-.46-.126-.642.037-.22.026-.355-.012-.443Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      d: "M23.185 14.118c-.113-.349-.54-.73-.749-.82l-.011-.187c.112-.045.383-.255.507-.371.844.398 1.993-.166 2.522-.753l.203.122-.101.133-.107-.056c-.13.155-.613.603-.76.697.197.049.466.082.54.078.473-.332.845-.63 1.025-.653l.152.2-.135.093-.107-.06c-.507.41-1.081 1.306-1.307 1.904-.315-.067-1.441-.023-1.672-.327Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M22.712 14.76c-.106-.263-.051-.812 1.159-.777 1.404.04 1.561.777 1.414 1.03-.664-.317-1.43-.34-2.573-.253Z"
    }
  )
), "SvgComponent"), SvgFlagPcn = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagPcn_default = SvgFlagPcn;
export {
  FlagPcn_default as default
};
